import { useTheme } from 'styled-components';

import ProfessionalPNG from '../../../assets/Professional.png';
import { Typography } from '../../../designComponents';
import { ContainerStyled, ProfessionalSloganStyled } from './style';

const ProfessionalSlogan = () => {
  const theme = useTheme();
  return (
    <ProfessionalSloganStyled>
      <ContainerStyled>
        <div className="main-text">
          <Typography
            style={{ color: theme.colors.landingSecondaryText }}
            strong
            variant="heading"
            className="text"
          >
            Professional Digital Escape Plan Services Tailored to Your Needs
          </Typography>
          <Typography variant="title" className="title">
            Our team of expert escape plan technicians specializes in creating
            precise digital drawings for your building's escape routes. With
            meticulous attention to detail, we ensure that every aspect of your
            escape plan meets both professional standards and your specific
            requirements. Our process begins with thorough verification and
            refinement of the initial drawing, incorporating feedback from both
            our team of professionals and you, our valued client.
          </Typography>
        </div>
        <div>
          <img src={ProfessionalPNG} alt="professional-img" className="img" />
        </div>
      </ContainerStyled>
    </ProfessionalSloganStyled>
  );
};

export default ProfessionalSlogan;
